import Forum from '@/core/Forum.js'

window.Forum = Forum

$(document).ready(function() {
    // TODO initiate only when forum related page is active
    Forum.initialize()

    function thread_grow(element) {
        element.style.height = '10px'
        element.style.height = (element.scrollHeight) + 'px'

        if (element.value == '' || element.value == null) {
            element.style.height = '28px'
        }

        if (event.keyCode === 13) {
            element.style.height = (element.scrollHeight) + 28 + 'px'
        }
    }

    function forum_grow(element) {
        if (event.keyCode === 13 && !event.shiftKey) {
            event.preventDefault()
            if (element.value != '' || element.value != null) {
                element.closest('form').submit()
            }
            return false
        } else {
            element.style.height = '10px'
            element.style.height = (element.scrollHeight) + 'px'

            if (element.value == '' || element.value == null) {
                element.style.height = '28px'
            }
        }
    }
})
